import React from 'react'

function Global() {
  return <></>
}

export default Global
